module.exports = __webpack_public_path__ + "08_face.90ba78d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer1/08_face.png
// module id = C0KD
// module chunks = 0